export class aboutMiniData {
  text: string = '';
  imgUrl: string = '';
}
